<div class="flex flex-col">
  <form [formGroup]="inputForm">
    <div class="flex flex-row justify-start items-center">
      <mat-form-field appearance="outline" class="full-grow-no-shrink-no-basis">
        <mat-label>Title</mat-label>
        <input matInput formControlName="title"
               particleAnalytics
               analyticsCategory="data-survey"
               analyticsAction="create-custom-form">
      </mat-form-field>
    </div>
    <!--    <div fxLayout="row" fxLayoutAlign="start center">-->
    <!--      <mat-form-field appearance="outline" >-->
    <!--        <mat-label>Panel Type</mat-label>-->
    <!--        <mat-select formControlName="viewType">-->
    <!--          <mat-option value="Group">-->
    <!--            Section-->
    <!--          </mat-option>-->
    <!--          <mat-option value="Collapsible">-->
    <!--            Collapsible Section-->
    <!--          </mat-option>-->
    <!--          <mat-option value="Tab">-->
    <!--            Tab-->
    <!--          </mat-option>-->
    <!--        </mat-select>-->
    <!--      </mat-form-field>-->
    <!--    </div>-->
    <div class="flex flex-row justify-start items-center">
      <mat-checkbox formControlName="isTabbedForm">Create form with tabs</mat-checkbox>
    </div>
  </form>
</div>


